import { format } from 'date-fns';

export default (context, inject) => {
  const atMidnight = (value) => {
    if (!value) {
      return null;
    }
    const d = new Date(value);
    d.setHours(0);
    d.setMinutes(0);
    d.setSeconds(0);
    return d;
  };

  const dateOnly = (date) => {
    if (!date) {
      return null;
    }
    date = new Date(date);
    return new Date(date.valueOf() + date.getTimezoneOffset() * 60 * 1000);
  };

  const dateTime = (value, f) => {
    if (!value) {
      value = new Date();
    };
    if (typeof value === 'string') {
      value = new Date(value);
    }
    if (!f) {
      f = 'date';
    }
    let mask = {
      date: 'yyyy-MM-dd',
      displayDate: 'EEE do MMM yyyy',
      displayDateTime: 'EEE do MMM yyyy, HH:mm',
      shortDate: 'dd/MM/yyyy',
      timer: 'm:ss'
    }[f] || f;
    try {
      return format(value, mask);
    } catch (e) {
      console.error(e);
      return null;
    }
  };
  inject('dateTime', dateTime);
  context.$dateTime = dateTime;
  inject('atMidnight', atMidnight);
  context.$atMidnight = atMidnight;
  inject('dateOnly', dateOnly);
  context.$dateOnly = dateOnly;
};
